@if (form) {
  <form class="dialog-form position-relative">
    @if (form.length) {
      <div class="row">
        <app-form
          [formConfig]="form"
          [validationEmit]="validationEmit"
          [hasButton]="false"
          (onFilterSelectField)="onFilterSelect($event)"
          (onChange)="valueChanged($event)"
          [validationErrors]="validationErrors"
          (onSubmit)="submitForm($event)"
        >
        </app-form>
      </div>
    }

    @if (dataObj.data?.visible) {
      <div class="dialog-footer d-flex justify-content-between">
        <button type="button" [disabled]="isLoadingActionItem" class="btn btn-outline-main" (click)="onClose()">
          Cnacel
        </button>
        <button type="button" [disabled]="isLoadingActionItem" class="btn btn-solid-main" (click)="emitValidation()">
          @if (isLoadingActionItem) {
            <span class="spinner-border spinner-border-sm mr-1"></span>
          }
          {{ dataObj.data?.type == 'revoke' ? 'Revoke' : 'Assign' }}
        </button>
      </div>
    }
  </form>
}
